import React from 'react'
import { Radar } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js'
import { Box } from '@mui/material'

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend)

const RadarChartScore = ({ data, hasData }) => {
  const chartData = {
    labels: ['FREEDOM (%)', 'ADVENTUROUS (%)', 'TEAMWORK (%)', 'SYSTEMATIC (%)', 'AMBITIOUS (%)'],
    datasets: [
      {
        data: data,
        backgroundColor: '#FDF6E278',
        borderColor: '#F3BF3A',
        borderWidth: 4,
      },
    ],
  }

  const options = {
    plugins: {
      legend: {
        display: false,
      },
    },
    elements: {
      line: {
        borderWidth: 3,
      },
    },
    scales: {
      r: {
        pointLabels: {
          padding: 40,
          font: {
            size: '14px',
          },
        },
        suggestedMin: 0,
        suggestedMax: 100,
        ticks: {
          showLabelBackdrop: false,
          stepSize: 20,
          callback: function (value) {
            return value < 100 ? value : ''
          },
        },
        grid: {
          circular: true,
          color: ['#E5E5E5'],
        },
        backgroundColor: '#F7F9FA',
        beginAtZero: true,
      },
    },
  }

  chartData.datasets.forEach((dataset) => {
    dataset.pointStyle = false
  })

  const scoreData = [
    { label: 'freedom', right: '50%', top: '10.5%', score: data[0] },
    { label: 'adventurous', right: '11%', top: '42%', score: data[1] },
    { label: 'teamwork', right: '24%', top: '96%', score: data[2] },
    { label: 'systematic', right: '78%', top: '96%', score: data[3] },
    { label: 'ambitious', right: '88%', top: '42%', score: data[4] },
  ]

  return (
    <Box
      sx={{
        minHeight: '500px',
        minWidth: '700px',
        position: 'relative',
        ml: { xs: 40, md: 0 },
      }}
    >
      <Radar
        data={chartData}
        options={{
          ...options,
          maintainAspectRatio: false,
          responsive: true,
        }}
      />
      {hasData &&
        scoreData.map((data) => (
          <Box
            key={data.label}
            sx={{
              width: '35px',
              height: '35px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'absolute',
              backgroundColor: 'alternate.main',
              color: 'text.white',
              p: 2,
              right: data.right,
              top: data.top,
              borderRadius: '4.5px',
            }}
          >
            {data.score ?? '--'}
          </Box>
        ))}
    </Box>
  )
}

export default RadarChartScore
